import styled from "styled-components"
import { theme } from "../../../util/styles/theme"
import { BaseInput } from "../base-input/BaseInput"

export const TextareaInput = styled(BaseInput).attrs({
  as: "textarea",
  rows: 5,
})`
  ${theme.textStyle("paragraph", "medium", "normal")}
`
